{
  "navigation-back-button": {
    "text": {
      "back": "Quay lại",
      "home-page": "Trang chủ"
    }
  }
}
